import React, { useEffect, useState } from "react";
import SingleUserTestimonial from "../components/SingleUserTestimonial";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";

export default function UserFeedbacks() {
  // State Handling
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [fetchedData, setFetchedData] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Testimonials/Feedbacks From Database ---------
  const readingData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/read-contacts"
      );
      const result = await response.json();

      if (!response.ok) {
        setSuccess("");
        setError("Feedbacks can't be fetched");
      } else if (response.ok) {
        setTimeout(() => {
          setError("");
        }, 10000);
        const filteringFeedbacks = Array.from(
          new Set(
            result.filter((feedback) => {
              return feedback.user_query_type == "Feedback";
            })
          )
        );
        setFetchedData(filteringFeedbacks);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readingData();
  }, []);

  // --------- Deleting ---------
  const deleteHandler = async (contactId) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/delete-contact/${contactId}`,
      {
        method: "DELETE",
      }
    );

    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Feedback can't be deleted");
    } else if (response.ok) {
      setError("");
      setSuccess("Feedback Deleted Successfully");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    }

    // Reading the feedbacks again
    readingData();
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Fetching...</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/* All Feedbacks Heading Start */}
        <AdminPanelGeneralHeading text="All Feedbacks" />
        {/* All Feedbacks Heading End */}

        {/* All Feedbacks Cards Start*/}
        <div className="all-users-cards col-12 d-flex gap-4 flex-wrap justify-content-start align-items-stretch">
          {!fetchedData?.length ? <NothingToShow /> : ""}

          {fetchedData?.map((singleFeedback) => {
            return (
              <SingleUserTestimonial
                key={singleFeedback._id}
                userImg={singleFeedback.user_img}
                userName={singleFeedback.user_name}
                userEmail={singleFeedback.user_email}
                testimonialText={singleFeedback.user_message}
                contactId={singleFeedback._id}
                deleteHandler={deleteHandler}
              />
            );
          })}
        </div>
        {/* All Feedbacks Cards End */}
      </>
    );
}
